/* eslint-disable react/prop-types */
import React from 'react';
import classNames from 'classnames';
import './_styles.scss';
import { useTranslation } from 'react-i18next';
import { ZCDFlex, ZCDIcon, ZCDIconColor, ZCDSpacer, ZCDTooltip } from '@zencity/common-ui';

/**
 * Sentiment Anaysis:
 * Ported from civilspace-client-instances-management
 */

const calculateRelativePercentage = (current, total) => {
  return parseFloat(((current / total) * 100).toFixed(2));
};

const SentimentSegment = ({ foregroundStyle, width, label, percentage, count }) => {
  const { t } = useTranslation();
  return (
    <div
      className={classNames('engage-sentiment-analysis-foreground', foregroundStyle)}
      style={{ width: `${width}%` }}
    >
      <ZCDTooltip
        text={
          <table>
            <tr>
              <td>
                <strong>{t('sentimentAnalysis.tableHeader')}</strong>
              </td>
              <td />
            </tr>
            <tr>
              <td>{label}</td>
              <td>{`${percentage}%`}</td>
            </tr>
            <tr>
              <td>{t('sentimentAnalysis.count')}</td>
              <td>{count}</td>
            </tr>
          </table>
        }
      >
        <div className={classNames('engage-sentiment-tooltip-element')} />
      </ZCDTooltip>
    </div>
  );
};

// eslint-disable-next-line max-lines-per-function, complexity, max-statements
function SentimentAnalysis({ isReportBuilder, sentimentAnalysis }) {
  // const sentimentAnalysis: SentimentSummary = mockSentimentAnalysis;
  const { t } = useTranslation();
  const positiveCount = parseFloat(sentimentAnalysis?.positive?.count || '0');
  const mixedCount = parseFloat(sentimentAnalysis?.mixed?.count || '0');
  const neutralCount = parseFloat(sentimentAnalysis?.neutral?.count || '0');
  const negativeCount = parseFloat(sentimentAnalysis?.negative?.count || '0');
  const totalCount = positiveCount + mixedCount + neutralCount + negativeCount;
  const relPositivePercent = calculateRelativePercentage(positiveCount, totalCount);
  const relMixedPercent = calculateRelativePercentage(mixedCount, totalCount);
  const relNeutralPercent = calculateRelativePercentage(neutralCount, totalCount);
  const relNegativePercent = calculateRelativePercentage(negativeCount, totalCount);
  return (
    <>
      <hr />
      {!isReportBuilder && <ZCDSpacer orientation="vertical" size="small" />}
      <ZCDFlex>
        <strong>{t('sentimentAnalysis.title')}</strong>{' '}
        {!isReportBuilder && (
          <ZCDTooltip text={t('sentimentAnalysis.tooltip')}>
            <ZCDIcon
              name="info"
              color={ZCDIconColor.BLUE}
              className={classNames('engage-sentiment-info-icon')}
            />
          </ZCDTooltip>
        )}
      </ZCDFlex>
      {!isReportBuilder && <ZCDSpacer orientation="vertical" size="xsmall" />}
      <ZCDFlex alignItems="center" style={{ gap: '1rem' }}>
        {`${sentimentAnalysis?.positive?.percentage || 0}%`}
        <ZCDFlex className={classNames('engage-sentiment-analysis-background')} width="100%">
          {sentimentAnalysis?.positive && (
            <SentimentSegment
              foregroundStyle={'positive'}
              width={relPositivePercent}
              label={t('sentimentAnalysis.positive')}
              percentage={sentimentAnalysis.positive.percentage}
              count={sentimentAnalysis.positive.count}
            />
          )}
          {sentimentAnalysis?.mixed && (
            <SentimentSegment
              foregroundStyle={'mixed'}
              width={relMixedPercent}
              label={t('sentimentAnalysis.mixed')}
              percentage={sentimentAnalysis.mixed.percentage}
              count={sentimentAnalysis.mixed.count}
            />
          )}
          {sentimentAnalysis?.neutral && (
            <SentimentSegment
              foregroundStyle={'neutral'}
              width={relNeutralPercent}
              label={t('sentimentAnalysis.neutral')}
              percentage={sentimentAnalysis.neutral.percentage}
              count={sentimentAnalysis.neutral.count}
            />
          )}
          {sentimentAnalysis?.negative && (
            <SentimentSegment
              foregroundStyle={'negative'}
              width={relNegativePercent}
              label={t('sentimentAnalysis.negative')}
              percentage={sentimentAnalysis.negative.percentage}
              count={sentimentAnalysis.negative.count}
            />
          )}
        </ZCDFlex>
        {`${sentimentAnalysis?.negative?.percentage || 0}%`}
      </ZCDFlex>
      <ZCDSpacer orientation="vertical" size="small" />
      {isReportBuilder && (
        <div data-testid="sentiment-legend">
          <ZCDFlex justifyContent="center" style={{ gap: '.5rem' }}>
            <div>
              <span className={classNames('engage-sentiment-legend', 'positive')} />
              {t('sentimentAnalysis.positive')} (
              {`${sentimentAnalysis?.positive?.percentage || 0}%`})
            </div>
            <div>
              <span className={classNames('engage-sentiment-legend', 'mixed')} />
              {t('sentimentAnalysis.mixed')} ({`${sentimentAnalysis?.mixed?.percentage || 0}%`})
            </div>
            <div>
              <span className={classNames('engage-sentiment-legend', 'neutral')} />
              {t('sentimentAnalysis.neutral')} ({`${sentimentAnalysis?.neutral?.percentage || 0}%`})
            </div>
            <div>
              <span className={classNames('engage-sentiment-legend', 'negative')} />
              {t('sentimentAnalysis.negative')} (
              {`${sentimentAnalysis?.negative?.percentage || 0}%`})
            </div>
          </ZCDFlex>
          <ZCDSpacer orientation="vertical" size="small" />
        </div>
      )}
      {
        <>
          <hr />
          <ZCDSpacer orientation="vertical" size="small" />
        </>
      }
    </>
  );
}

export default SentimentAnalysis;
